import { FilestackImageData } from 'api/types/shared.types';
import { Hero } from 'components/Hero';
import { H1 } from 'components/Text/H1';
import { RichText } from 'components/Text/RichText';
import PostSearchInputContainer from 'containers/PostSearchInputContainer';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { useCmsApiPageSubsite } from 'modules/cms/hooks';

import {
  ArticleSearchHeroContainer,
  ArticleSearchHeroTitle,
  ArticleSearchHeroWrapper,
} from './ArticleSearchHero.styled';

type Props = {
  content: CmsApiPage;
  title?: string;
  image: FilestackImageData | null | undefined;
  imageMobile: FilestackImageData | null | undefined;
  searchMode?: boolean;
};

export function ArticleSearchHero({
  content,
  title,
  image,
  imageMobile,
  searchMode,
}: Props) {
  const subsite = useCmsApiPageSubsite({ cmsApiPage: content });

  return (
    <Hero
      py={[40, null, 72, 108]}
      // @ts-expect-error TS(2322): Type 'FilestackImageData | null | undefined' is no... Remove this comment to see the full error message
      heroImage={image}
      minHeight={['244px', null, '323px', '394px']}
      // @ts-expect-error TS(2322): Type 'FilestackImageData | null | undefined' is no... Remove this comment to see the full error message
      mobileHeroImage={imageMobile}
      data-qa-id="article-search-hero"
    >
      {!searchMode && (
        <ArticleSearchHeroContainer>
          <ArticleSearchHeroWrapper>
            <RichText mb={24}>
              <H1>
                <ArticleSearchHeroTitle
                  lineHeight={1.3}
                  dangerouslySetInnerHTML={{
                    // @ts-expect-error TS(2769): No overload matches this call.
                    __html: title?.replace(/<(\/?)(p|h1)>/g, '<$1span>'),
                  }}
                />
              </H1>
            </RichText>
            <PostSearchInputContainer
              homePageUrl={subsite ? subsite.homePage.url : ''}
              searchPlaceholderText={
                subsite?.searchPlaceholderText
                  ? subsite.searchPlaceholderText
                  : undefined
              }
              usageContext="searchHero"
            />
          </ArticleSearchHeroWrapper>
        </ArticleSearchHeroContainer>
      )}
    </Hero>
  );
}
